import { styled } from '@mui/material/styles';
export var StyledEditor = styled('div')(function (_ref) {
  var showError = _ref.showError,
    theme = _ref.theme;
  return {
    width: '100%',
    padding: theme.spacing(6, 4),
    backgroundImage: "linear-gradient(45deg, " + theme.palette.grey[700] + " 25%, transparent 25%), linear-gradient(-45deg, " + theme.palette.grey[700] + " 25%, transparent 25%), linear-gradient(45deg, transparent 75%, " + theme.palette.grey[700] + " 75%), linear-gradient(-45deg, transparent 75%, " + theme.palette.grey[700] + " 75%)",
    backgroundSize: '20px 20px',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    backgroundPosition: '0 0, 0 10px, 10px -10px, -10px 0px',
    border: "1px solid " + (showError ? theme.palette.error.main : theme.palette.primary.main),
    borderRadius: theme.shape.borderRadius,
    '& .ReactCrop': {
      margin: '0 auto',
      display: 'block'
    }
  };
});